import { useState } from "react";
import AuthModal from "@/components/auth/AuthModal";

export const AnimatedAuthButton = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsAuthModalOpen(true)}
        className="font-fredoka font-semibold text-sm px-6 py-2.5 rounded-full bg-amber-400 hover:bg-amber-500 text-gray-800 shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
      >
        Join TinyMinds
      </button>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </>
  );
};
